import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { ServiceRoute } from "../../base/service-route";

import { CoreService } from "../../base/core";
import { ICompany } from "src/app/interfaces/company";
import { CommonHttpOption } from "../../base/common-http-option";
import { ICompanyManager } from "src/app/interfaces/companyManager";

@Injectable({
  providedIn: "root"
})
export class CompanyService {
  constructor(private core: CoreService) { }

  list(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.company.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  companyById(): Observable<any> {
    return this.core.get(
      ServiceRoute.company.companyById,
      new CommonHttpOption().headers
    );
  }

  add(data: ICompany): Observable<any> {
    return this.core.post(
      ServiceRoute.company.add,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: ICompany): Observable<any> {
    return this.core.put(
      ServiceRoute.company.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.company.delete,
      new CommonHttpOption().headers,
      data
    );
  }

  addManger(data: ICompanyManager): Observable<any> {
    return this.core.post(
      ServiceRoute.company.addManager,
      data,
      new CommonHttpOption().headers
    );
  }

  saveManager(data: ICompanyManager): Observable<any> {
    return this.core.post(
      ServiceRoute.company.saveManager,
      data,
      new CommonHttpOption().headers
    );
  }
}
